import { useMemo } from "react";
import { SectionPage } from "@/components/section-page";
import { DataTable } from "@/composites/data-table/index";
import { HardwareItemType } from "@/schemas/hardware";
import { useTableToInstallStyles } from "./table-to-install.styles";
import { LocalizationText } from "@/app/index";
import { ProductImage } from "@/components/product-image/index";
import { Link } from "@/components/link";
import { Text, Flex } from "@/base/components/index";
import { usePageContextHardware } from "../../context/hardware-context";

export const TableToInstall = () => {
  const { styles } = useTableToInstallStyles();
  const { controllerDataTableToInstall, currentLang } =
    usePageContextHardware();

  const columns: any = useMemo(
    () => [
      {
        dataIndex: "ProductName",
        title: (
          <LocalizationText value="hardware.table.to.install.column.hardware" />
        ),
        minWidth: 200,
        render: (value: string, record: HardwareItemType) => (
          <Flex align="center" gap={12}>
            <ProductImage
              src={record.Product?.ImageThumbName}
              width={40}
              height={40}
            />
            <Text>{value}</Text>
          </Flex>
        ),
      },
      {
        dataIndex: "BusinessUnitName",
        minWidth: 160,
        title: (
          <LocalizationText value="hardware.table.to.install.column.business.unit" />
        ),
        render: (text: string, record: HardwareItemType) =>
          record.BusinessUnitId && text ? (
            <Link
              to={`/${currentLang}/business-units/${record.BusinessUnitId}`}
              type="primary"
              strong
            >
              {text}
            </Link>
          ) : (
            text
          ),
      },
      {
        dataIndex: "LicenseKey",
        minWidth: 160,
        title: (
          <LocalizationText value="hardware.table.to.install.column.key" />
        ),
      },
      {
        dataIndex: "ProductStatusName",
        minWidth: 160,
        title: (
          <LocalizationText value="hardware.table.to.install.column.status" />
        ),
      },
      {
        dataIndex: "Actions",
        minWidth: 160,
        title: (
          <LocalizationText value="hardware.table.to.install.column.actions" />
        ),
        render: (_: any, record: HardwareItemType) => {
          if (
            [100000000, 100000001, 100000002, 100000003].includes(
              record.ProductStatusCode || 0,
            ) &&
            record.SwitchAssigned != true
          ) {
            return (
              <LocalizationText value="hardware.table.to.install.column.actions.not.ready.to.install" />
            );
          }

          if (
            [100000004, 100000009, 100000022].includes(
              record.ProductStatusCode || 0,
            ) &&
            record.SwitchAssigned == true
          ) {
            return (
              <LocalizationText value="hardware.table.to.install.column.actions.installation.in.progress" />
            );
          }
        },
      },
    ],
    [],
  );

  return (
    <SectionPage
      classNames={{
        section: styles.section,
        body: styles.body,
      }}
    >
      <DataTable
        controller={controllerDataTableToInstall}
        columns={columns}
        searched={false}
      />
    </SectionPage>
  );
};
